module.exports = __webpack_public_path__ + "static/ImageTalent-c804be6b6904d1781e94087e62b0f871.png";